import { defineComponent as _defineComponent } from 'vue'
import CommonButton from '@/components/CommonButton.vue';
import CommonInput from '@/components/CommonInput.vue';
import { WhatsappUtils } from '@/utils/whatsapp_utils';
import Constants from '@/infra/constants/constants';
import AlertModal from '@/components/modals/AlertModal.vue';
import LoadingModal from '@/components/modals/LoadingModal.vue';
import { Icons } from '@/font-awesome';
import { AlertModalInjection, LoadingModalInjection } from '@/infra/constants/injections';
import LoggedAdminStorage from '@/infra/local_storage/logged_admin_storage';
import { routes } from '@/router';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { useUserStore } from '@/stores/users/user_store';
import { Ref, inject, ref } from 'vue';
import { useRouter } from 'vue-router';
import { CardCategoryType } from '../models/benefits_cards/card_category_type';


export default /*@__PURE__*/_defineComponent({
  __name: 'LoginView',
  setup(__props, { expose: __expose }) {
  __expose();

const userStore = useUserStore();
const alertModal = inject<Ref<InstanceType<typeof AlertModal>>>(AlertModalInjection);
const loadingModal = inject<Ref<InstanceType<typeof LoadingModal>>>(LoadingModalInjection);

const router = useRouter();

async function login() {
  try {
    loadingModal?.value.open();
    userStore.emailError = '';
    userStore.passwordError = '';
    const res = await userStore.login();
    if (res?.isError()) {
      alertModal?.value?.open({
        icon: Icons.imported.faCircleExclamation,
        title: 'Erro ao logar',
        titleColor: 'error',
        content: res.getError() ?? 'Erro desconhecido',
      });
      return;
    }
    if (res) {
      const user = LoggedAdminStorage.getUser();
      router.push({
        name: user?.getIsSuperAdmin() ? routes.deliveryAreas.name : routes.welcome.name,
        params: {
          deliveryAreaId: user?.getDeliveryAreaId(),
        }
      });
    }

  } finally {
    loadingModal?.value.close();
  }
}


const __returned__ = { userStore, alertModal, loadingModal, router, login, CommonButton, CommonInput, get WhatsappUtils() { return WhatsappUtils }, get Constants() { return Constants }, get Icons() { return Icons }, get routes() { return routes }, get FontAwesomeIcon() { return FontAwesomeIcon } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})